import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "form-group" }
const _hoisted_2 = {
  key: 0,
  style: {"color":"red"}
}
const _hoisted_3 = ["title", "required", "readonly", "minlength", "maxlength"]
const _hoisted_4 = { class: "error" }
const _hoisted_5 = {
  key: 0,
  class: "form-text text-muted"
}

import { computed, toRef } from 'vue'

    import type { AlternativeEditorAttributeFieldReadModel } from '@Alternatives/Alternatives/Domain/readmodels'
    import type { ValidationError } from '@common/types'

    // ---------------- props ----------------

    
export default /*@__PURE__*/_defineComponent({
  __name: 'TextInputSingleValue',
  props: {
    propF: {},
    propErrors: {}
  },
  setup(__props: any) {

    const props = __props

    // ---------------- shortcuts ----------------

    const f = toRef(props, 'propF')
    const errors = toRef(props, 'propErrors')

    // ---------------- computed ----------------

    const error = computed(() =>
        errors.value?.find(e =>
            e.Context.startsWith(`AlternativeAttribute:${f.value.Id}`)
        )?.Error
    )

    const tooltipText = computed(() =>
    {
        let tooltip = 'Please enter text'
        if (f.value.IsRequired) tooltip += ', required'
        if (f.value.MinLength) tooltip += `, minimum length: ${f.value.MinLength}`
        if (f.value.MaxLength) tooltip += `, maximum length: ${f.value.MaxLength}`
        return tooltip
    })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("label", null, [
      (f.value.IsRequired)
        ? (_openBlock(), _createElementBlock("span", _hoisted_2, "*"))
        : _createCommentVNode("v-if", true),
      _createTextVNode(" " + _toDisplayString(f.value.Name), 1 /* TEXT */)
    ]),
    _withDirectives(_createElementVNode("input", {
      type: "text",
      class: "form-control",
      placeholder: "Enter text...",
      title: tooltipText.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((f.value.Value) = $event)),
      required: f.value.IsRequired === true,
      readonly: f.value.IsReadonly === true,
      minlength: f.value.MinLength != null ? f.value.MinLength : null,
      maxlength: f.value.MaxLength != null ? f.value.MaxLength : null
    }, null, 8 /* PROPS */, _hoisted_3), [
      [
        _vModelText,
        f.value.Value,
        void 0,
        { trim: true }
      ]
    ]),
    _createElementVNode("div", _hoisted_4, _toDisplayString(error.value), 1 /* TEXT */),
    (f.value.Description)
      ? (_openBlock(), _createElementBlock("small", _hoisted_5, _toDisplayString(f.value.Description), 1 /* TEXT */))
      : _createCommentVNode("v-if", true)
  ]))
}
}

})